"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TextEffect2 = _interopRequireDefault(require("./TextEffect"));

var _convertEmToPixel = _interopRequireDefault(require("../../../utils/font/convertEmToPixel"));

var _isNotNumber = _interopRequireDefault(require("../../../utils/numbers/isNotNumber"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FillTextEffect = /*#__PURE__*/function (_TextEffect) {
  (0, _inherits2["default"])(FillTextEffect, _TextEffect);

  var _super = _createSuper(FillTextEffect);

  function FillTextEffect() {
    (0, _classCallCheck2["default"])(this, FillTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FillTextEffect, null, [{
    key: "fillRect",

    /*
    * fillRect with border radius
    * https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
    */
    value: function fillRect(context, x, y, w, h) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

      if ((0, _isNotNumber["default"])(r) || r <= 0) {
        context.fillRect(x, y, w, h);
        return;
      }

      if (w < 2 * r) r = w / 2;
      if (h < 2 * r) r = h / 2;
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + w, y, x + w, y + h, r);
      context.arcTo(x + w, y + h, x, y + h, r);
      context.arcTo(x, y + h, x, y, r);
      context.arcTo(x, y, x + w, y, r);
      context.closePath();
      context.fill();
    }
  }, {
    key: "getHorizontalPadding",
    value: function getHorizontalPadding(fontSize) {
      return (0, _convertEmToPixel["default"])(this._DEFAULT_HORIZONTAL_SPACING_EM, fontSize);
    }
    /*
     * getLongestLine
     */

  }, {
    key: "getLongestLine",
    value: function getLongestLine(lines) {
      // find the longest line
      var longestLineWidth = 0;
      var longestLine = lines[0];
      lines.forEach(function (line) {
        var width = line.width;
        if (width < longestLineWidth) return;
        longestLineWidth = width;
        longestLine = line;
      });
      return longestLine;
    }
  }, {
    key: "getMostLeftLine",
    value: function getMostLeftLine(lines) {
      // find the most left line
      var mostLeftX = 0;
      var mostLeftLine = lines[0];
      lines.forEach(function (line) {
        var actualBoundingBoxLeft = line.actualBoundingBoxLeft;
        if (actualBoundingBoxLeft < mostLeftX) return;
        mostLeftX = actualBoundingBoxLeft;
        mostLeftLine = line;
      });
      return mostLeftLine;
    }
  }, {
    key: "getMostRightLine",
    value: function getMostRightLine(lines) {
      // find the most left line
      var mostRightX = 0;
      var mostRightLine = lines[0];
      lines.forEach(function (line) {
        var width = line.width,
            x = line.x;
        var rightX = width + x;
        if (width + x > mostRightX) return;
        mostRightX = rightX;
        mostRightLine = line;
      });
      return mostRightLine;
    }
  }, {
    key: "getFillTextProperties",
    value: function getFillTextProperties(lines) {
      var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var longestLine = this.getLongestLine(lines);
      var mostLeftLine = this.getMostLeftLine(lines); // find the longest line

      var actualBoundingBoxLeftOfLongest = longestLine.actualBoundingBoxLeft,
          longestLineWidth = longestLine.width;
      var actualBoundingBoxLeft = mostLeftLine.actualBoundingBoxLeft,
          x = mostLeftLine.x;
      var lineFillX = x - actualBoundingBoxLeft - padding;
      var diffX = actualBoundingBoxLeft - actualBoundingBoxLeftOfLongest;
      var lineFillWidth = longestLineWidth + diffX + 2 * padding;
      return {
        lineFillWidth: lineFillWidth,
        lineFillX: lineFillX
      };
    }
  }]);
  return FillTextEffect;
}(_TextEffect2["default"]);

exports["default"] = FillTextEffect;
(0, _defineProperty2["default"])(FillTextEffect, "_DEFAULT_HORIZONTAL_SPACING_EM", 0.16);